import sdl from '@jds/react-generated-sdl/JDSLink';
import type { JDSLinkProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, LinkProps } from '../logic';

const Component = (props: LinkProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    textAppearance = 'undefined',
    kind = 'default',
    ariaLabel = props.title?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { textAppearance, kind, ariaLabel, ...rest },
    'JDSLink',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Link = withLogic(Component) as React.ForwardRefExoticComponent<
  LinkProps & React.RefAttributes<HTMLDivElement>
> & { slotName?: string };

Link.displayName = 'Link';
Link.slotName = 'jds_link';

export { Link, type JDSLinkProps };
